import React from "react";
import { Col, Row } from "react-bootstrap";
import { SiNextdotjs, SiAngular, SiInsomnia, SiNodedotjs, SiExpress } from "react-icons/si";
import javascript from "../../Assets/TechIcons/javascript.svg";
import ReactIcon from "../../Assets/TechIcons/React.svg";
import java from "../../Assets/TechIcons/java.svg";
import python from "../../Assets/TechIcons/python.svg";
import typescript from "../../Assets/TechIcons/typescript.svg";
import Git from "../../Assets/TechIcons/git.svg";
import Mongo from "../../Assets/TechIcons/Mongo.svg";
import SQL from "../../Assets/TechIcons/SQL.svg";
import MUI from "../../Assets/TechIcons/MUI.svg";
import postman from "../../Assets/TechIcons/postman.svg";
import html from "../../Assets/TechIcons/html.svg";
import css from "../../Assets/TechIcons/css.svg";
import bootstrap from "../../Assets/TechIcons/bootstrap.svg";
import django from "../../Assets/TechIcons/django.svg";
import mysql from "../../Assets/TechIcons/mysql.svg";

function Techstack() {
  return (
    <div style={{ paddingBottom: "50px" }}>
      <h3 style={{ color: "#58a6ff", marginBottom: "20px", fontWeight: 600 }}>Frontend</h3>
      <Row style={{ justifyContent: "center", paddingBottom: "40px" }}>
        <Col xs={4} md={2} className="tech-icons">
          <img src={html} alt="html" />
          <div className="tech-icons-text">HTML5</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <img src={css} alt="css" />
          <div className="tech-icons-text">CSS3</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <img src={javascript} alt="javascript" />
          <div className="tech-icons-text">JavaScript</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <img src={typescript} alt="typescript" />
          <div className="tech-icons-text">TypeScript</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiAngular fontSize={"24px"} color="#dd0031" />
          <div className="tech-icons-text">Angular</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <img src={bootstrap} alt="bootstrap" />
          <div className="tech-icons-text">Bootstrap</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <img src={ReactIcon} alt="react" />
          <div className="tech-icons-text">React</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiNextdotjs fontSize={"24px"} color="#ffffff" />
          <div className="tech-icons-text">Next.js</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <img src={MUI} alt="mui" />
          <div className="tech-icons-text">Material UI</div>
        </Col>
      </Row>

      <h3 style={{ color: "#58a6ff", marginBottom: "20px", fontWeight: 600 }}>Backend</h3>
      <Row style={{ justifyContent: "center", paddingBottom: "40px" }}>
        <Col xs={4} md={2} className="tech-icons">
          <SiNodedotjs fontSize={"24px"} color="#339933" />
          <div className="tech-icons-text">Node.js</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiExpress fontSize={"24px"} color="#ffffff" />
          <div className="tech-icons-text">Express</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <img src={python} alt="Python" />
          <div className="tech-icons-text">Python</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <img src={java} alt="java" />
          <div className="tech-icons-text">Java</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <img src={django} alt="django" />
          <div className="tech-icons-text">Django</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <img src={mysql} alt="mysql" />
          <div className="tech-icons-text">MySQL</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <img src={Mongo} alt="mongoDb" />
          <div className="tech-icons-text">MongoDB</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <img src={SQL} alt="postgresql" />
          <div className="tech-icons-text">PostgreSQL</div>
        </Col>
      </Row>

      <h3 style={{ color: "#58a6ff", marginBottom: "20px", fontWeight: 600 }}>Herramientas</h3>
      <Row style={{ justifyContent: "center", paddingBottom: "40px" }}>
        <Col xs={4} md={2} className="tech-icons">
          <img src={Git} alt="git" />
          <div className="tech-icons-text">Git</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <SiInsomnia fontSize={"24px"} color="#4000bf" />
          <div className="tech-icons-text">Insomnia</div>
        </Col>
        <Col xs={4} md={2} className="tech-icons">
          <img src={postman} alt="Postman" />
          <div className="tech-icons-text">Postman</div>
        </Col>
      </Row>
    </div>
  );
}

export default Techstack;
